import type { AsyncState } from '@essent/common';
import {
  createAsyncStateReducer,
  createInitialAsyncState,
} from '@essent/common';
import type { Action } from '@ngrx/store';
import type { GetDynamicPricesAvailabilityResponse } from '@integration/api-client/tariffmanagement';

import { tariffsActions } from '../../shared/tariffs.ngrx-wrapper';

export type DynamicPricesAvailabilityState =
  AsyncState<GetDynamicPricesAvailabilityResponse>;

export const initialDynamicPricesAvailabilityState: DynamicPricesAvailabilityState =
  createInitialAsyncState();

const _reducer = createAsyncStateReducer(
  tariffsActions.getDynamicPricesAvailability
);

export function dynamicPricesAvailabilityReducer(
  state = initialDynamicPricesAvailabilityState,
  action: Action
) {
  return _reducer(state, action);
}
